// @flow
import * as React from 'react';

import impossible from 'common/types/impossible';

type Props = {|
  renderToggle: ({ open: () => void, ... }) => React.Node,
  renderModal: ({ close: () => void, ... }) => React.Node
|};
type Closed = {|
  status: 'CLOSED'
|};
type Open = {|
  status: 'OPEN'
|};
type State = {|
  modal: Closed | Open
|};

const open: Open = { status: 'OPEN' };
const closed: Closed = { status: 'CLOSED' };

export default class ModalToggle extends React.Component<Props, State> {
  state: State = { modal: closed };

  render(): React.Node {
    switch (this.state.modal.status) {
      case 'CLOSED':
        return (
          <div>
            {this.props.renderToggle({
              open: () => this.setState({ modal: open })
            })}
          </div>
        );
      case 'OPEN':
        return (
          <div>
            {this.props.renderToggle({ open: () => {} })}
            {this.props.renderModal({
              close: () => this.setState({ modal: closed })
            })}
          </div>
        );
      default:
        return impossible(this.state.modal.status);
    }
  }
}
